import { MenuItem, OuiMenuComponent } from '@aiz-gl/omni-ui';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dropdown-menu',
  imports: [OuiMenuComponent],
  templateUrl: './dropdown-menu.component.html',
  standalone: true,
  styles: [
    `
      .loc-pill {
        appearance: none;
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.375rem 0.625rem 0.375rem 0.875rem;
        background: var(--surface);
        border: 1px solid var(--border);
        border-radius: 999px;
        color: var(--text);
        font: inherit;
        font-size: 0.85rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 150ms ease, border-color 150ms ease;
      }

      .loc-pill:hover {
        background: var(--subtle);
        border-color: var(--border-light);
      }

      .loc-pill__label {
        line-height: 1.2;
      }

      .loc-pill__chev {
        width: 1rem;
        height: 1rem;
        color: var(--text-muted);
        flex-shrink: 0;
      }
    `,
  ],
})
export class DropdownMenuComponent {
  @Input() selectedLabel!: string;
  @Input() menuItems: MenuItem[] = [];
  @Output() menuItemSelected = new EventEmitter<MenuItem>();

  onMenuItemClicked(item: MenuItem) {
    this.menuItemSelected.emit(item);
  }
}
